/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {FindEmploymentsRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {FindEmploymentsResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const findEmployments = (request: FindEmploymentsRequest, options?: CashRequestOptions) => post<FindEmploymentsRequest, FindEmploymentsResponse>("/2.0/cash/find-employments", request, {...options, rejectOnError: true })